module.exports = __webpack_public_path__ + "static/bar04_3_mobile-d4ef4067fee72b0c29093fef4ac424da.png";